import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture `beforeinstallprompt` AS EARLY AS POSSIBLE.
// This event fires once during initial page load — often before React mounts —
// so if we wait for a useEffect inside a component, the event is lost forever
// and the Install button can never trigger the native install dialog.
// We stash it on `window` so InstallBanner can read it on mount.
window.__icDeferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__icDeferredInstallPrompt = e;
  try { localStorage.setItem('pwaPromptAvailable', 'true'); } catch (_) {}
  window.dispatchEvent(new CustomEvent('ic-install-prompt-ready'));
});
window.addEventListener('appinstalled', () => {
  try {
    localStorage.setItem('ic_app_installed', 'true');
    localStorage.removeItem('pwaPromptAvailable');
    localStorage.removeItem('ic_install_remind_later');
  } catch (_) {}
  window.__icDeferredInstallPrompt = null;
  window.dispatchEvent(new CustomEvent('ic-installed'));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Remove the branded boot splash once React has mounted.
requestAnimationFrame(() => {
  const splash = document.getElementById('app-boot-splash');
  if (splash) {
    splash.style.transition = 'opacity 0.35s ease';
    splash.style.opacity = '0';
    setTimeout(() => splash.remove(), 380);
  }
});
